/* eslint-disable @typescript-eslint/no-explicit-any */
'use client';

import { ExternalLink } from 'lucide-react';

export default function ProjectCard({
  project,
  onOpenModal,
}: {
  project: any;
  onOpenModal: (item: any) => void;
}) {
  return (
    <div
      onClick={() => onOpenModal(project)}
      className="group relative glass-dark rounded-3xl transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_20px_50px_rgba(0,0,0,0.5)] overflow-hidden border border-white/5 hover:border-white/20 flex flex-col h-full cursor-pointer"
    >
      <div className="absolute -inset-1 bg-gradient-to-br from-primary/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 blur-2xl -z-10" />

      <div className="absolute top-0 right-0 p-4 sm:p-5 lg:p-6 opacity-0 group-hover:opacity-100 transition-all duration-300 translate-x-2 group-hover:translate-x-0 z-10">
        <ExternalLink className="w-4 h-4 sm:w-5 sm:h-5 text-primary" />
      </div>

      <div className="relative flex flex-col gap-4 sm:gap-5 lg:gap-6 p-5 sm:p-6 lg:p-8 flex-grow">
        <div>
          <h3 className="text-lg sm:text-xl font-bold text-foreground group-hover:text-primary transition-colors tracking-tight line-clamp-1">
            {project.title}
          </h3>
          <p className="text-muted-foreground line-clamp-3 mt-2 sm:mt-3 text-sm leading-relaxed">
            {project.description}
          </p>
        </div>

        <div className="flex flex-wrap gap-1.5 sm:gap-2 mt-auto">
          {(project.tech || []).map((tag: string) => (
            <span
              key={tag}
              className="text-[9px] sm:text-[10px] font-bold uppercase tracking-widest px-2 sm:px-2.5 py-1 rounded-md bg-white/5 border border-white/10 text-muted-foreground group-hover:border-primary/30 group-hover:text-foreground transition-colors"
            >
              {tag}
            </span>
          ))}
        </div>

        <div className="mt-1 inline-flex items-center gap-2 text-xs sm:text-sm font-semibold text-primary/80 group-hover:text-primary transition-colors">
          View Details
          <div className="w-4 h-[1px] bg-primary/40 group-hover:w-8 transition-all" />
        </div>
      </div>
    </div>
  );
}
